import React from 'react';
import { motion } from 'framer-motion';

const ChampionCard = ({ champion, index, flashKey }) => {
    const borderColor = flashKey === 'D' ? 'border-yellow-500' : 'border-blue-500';
    const gradientColors = flashKey === 'D' 
        ? 'from-yellow-500/20 to-yellow-900/40' 
        : 'from-blue-500/20 to-blue-900/40';
        
    const getChampionImage = (championName) => {
        if (!championName) return null;
        // Fix for Fiddlesticks and ensure proper champion name handling
        const formattedName = championName === 'FiddleSticks' ? 'Fiddlesticks' : championName;
        return `https://ddragon.leagueoflegends.com/cdn/15.8.1/img/champion/${formattedName}.png`;
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
            className={`flex items-center rounded-lg overflow-hidden border ${borderColor} bg-gradient-to-br ${gradientColors} backdrop-filter backdrop-blur-sm w-full`}
        >
            <div className="pl-2 py-2 flex items-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-md overflow-hidden flex-shrink-0">
                    <img 
                        src={getChampionImage(champion.name) || `/api/placeholder/64/64`} 
                        alt={champion.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `/api/placeholder/64/64`;
                        }}
                    />
                </div>
            </div>
            
            <div className="p-2 pl-3 pr-4 sm:pr-12 flex-grow min-w-0">
                <h3 className="font-bold text-white truncate text-sm sm:text-base">{champion.name}</h3>
                <div className="flex items-center justify-between text-xs sm:text-sm space-x-1">
                    <div className="flex-shrink-0 whitespace-nowrap">
                        <span className="text-gray-300">{champion.games} games</span>
                    </div>
                    <div className="flex-shrink-0 whitespace-nowrap">
                        <span className={`font-bold ${champion.winRate >= 50 ? 'text-green-400' : 'text-red-400'}`}>
                            {champion.winRate}% WR
                        </span>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default ChampionCard;